import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './reset-password.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  private fb = inject(FormBuilder);
  private auth = inject(AuthService);
  public router = inject(Router);
  private route = inject(ActivatedRoute);

  token: string | null = null;
  loading = false;
  success = false;
  apiError: string | null = null;

  form = this.fb.group({
    password: ['', [Validators.required, Validators.minLength(8)]],
    confirmPassword: ['', [Validators.required]]
  });

  ngOnInit() {
    this.token = this.route.snapshot.queryParams['token'];
    if (!this.token) {
      this.apiError = 'Token manquant ou invalide';
    }
  }

  submit(): void {
    if (this.loading || !this.token) return;

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { password, confirmPassword } = this.form.value;
    
    if (password !== confirmPassword) {
      this.apiError = 'Les mots de passe ne correspondent pas';
      return;
    }

    this.apiError = null;
    this.loading = true;

    this.auth.resetPassword(this.token, password!).subscribe({
      next: () => {
        this.loading = false;
        this.success = true;
        setTimeout(() => this.router.navigateByUrl('/login'), 2000);
      },
      error: (err: any) => {
        this.loading = false;
        this.apiError = err?.error?.message || 'Erreur lors de la réinitialisation';
      }
    });
  }
}